import axios from "axios";

function getDefaultState() {
    return {
        settings: {
            prices: {
                fullAccess: 0,
                school: 0
            }
        },
        isLoaded: false
    }
}

const state = getDefaultState;

const getters = {
    settings: state => state.settings,

    fullAccessPriceFormatted: state => {
        // Ensure settings and prices exist before trying to access them
        const price = state.settings?.prices?.fullAccess ?? 0;
        return Number(price).toFixed(2);
    },

    schoolPriceFormatted: state => {
        const price = state.settings?.prices?.school ?? 0;
        return Number(price).toFixed(2);
    }
}

const actions = {
    async load({ commit }) {
        let settings = (await axios.get("/api/StripeSubscriptions/Settings")).data;
        commit("settings", settings);
    },
    clear({ commit }) {
        commit("clear");
    }
};

const mutations = {
    settings(state, settings) {
        state.settings = settings;
        state.isLoaded = true;
    },
    clear(state) {
        Object.assign(state, getDefaultState());
    }
}

export const stripe = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
